// src/components/Callback.jsx
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const API_BASE = "https://sy47l7fjif.execute-api.us-east-1.amazonaws.com/Prod";

function extractParams(location) {
  let params = new URLSearchParams(location.search);

  if ([...params.keys()].length > 0) {
    return params;
  }

  const rawHash = window.location.hash || "";
  const normalized = rawHash
    .replace(/^#/, "")
    .replace(/^!/, "")
    .replace(/^\//, "");

  if (normalized && !normalized.includes("?")) {
    return new URLSearchParams(normalized);
  }

  if (normalized.includes("?")) {
    return new URLSearchParams(normalized.split("?")[1] || "");
  }

  return new URLSearchParams();
}

const readCompanyContext = () => {
  try {
    return JSON.parse(localStorage.getItem("company_context") || "{}");
  } catch {
    return {};
  }
};

const Callback = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const run = async () => {
      const params = extractParams(location);

      const token =
        params.get("token") ||
        params.get("access_token") ||
        "";

      const spaceId =
        params.get("SpaceID") ||
        params.get("space_id") ||
        params.get("spaceId") ||
        params.get("space_slug") ||
        "";

      const connectMode = String(
        localStorage.getItem("connect_mode") || ""
      ).trim();

      const returnTo = String(
        localStorage.getItem("return_to") || "/company-dashboard"
      ).trim();

      const companyId = String(
        localStorage.getItem("company_id") || ""
      ).trim();

      const companyName = String(
        localStorage.getItem("company_name") || ""
      ).trim();

      console.log("Callback search:", location.search);
      console.log("Callback hash:", window.location.hash);
      console.log("Callback token:", token);
      console.log("Callback spaceId:", spaceId);
      console.log("Callback connectMode:", connectMode);
      console.log("Callback companyId:", companyId);

      if (!token || !spaceId) {
        console.error("OAuth callback missing token or spaceId");
        navigate("/", { replace: true });
        return;
      }

      localStorage.setItem("space_token", token);
      localStorage.setItem("space_id", spaceId);
      localStorage.setItem("token", token);
      localStorage.setItem("SpaceID", spaceId);
      localStorage.setItem("provider_context_id", spaceId);
      localStorage.setItem("provider_type", "cobot");
      localStorage.setItem("connected_provider_cobot", "true");

      if (companyId) {
        localStorage.setItem("company_id", companyId);
        localStorage.setItem("company_profile_completed", "true");
      }

      // Bestehende Firma + Cobot nachträglich anhängen
      if (connectMode === "attach_cobot" && companyId) {
        try {
          const res = await fetch(`${API_BASE}/provider_connection`, {
             method: "POST",
             headers: {
           "Content-Type": "application/json",
           "x-company-id": companyId,
           },
          body: JSON.stringify({
            company_id: companyId,
            provider: "cobot",
            external_id: spaceId,
            secret_name: "stored_in_cobot_tokens",
            metadata: {
             source: "callback_attach_cobot",
             space_id: spaceId,
             company_name: companyName || "",
    },
  }),
});

          let data = null;
          try {
            data = await res.json();
          } catch {
            data = null;
          }

          if (!res.ok) {
            console.error("provider_connection POST failed", data);
          } else {
            console.log("provider_connection saved", data);
          }
        } catch (err) {
          console.error("provider_connection attach failed", err);
        }

        try {
          const existingContext = readCompanyContext();

          const merged = {
            ...existingContext,
            company_id: companyId,
            provider_type: "cobot",
            provider_context_id: spaceId,
            legal_name:
              existingContext.legal_name ||
              existingContext.company_name ||
              companyName ||
              "",
            company_name:
              existingContext.company_name ||
              existingContext.legal_name ||
              companyName ||
              "",
            completed: true,
          };

          localStorage.setItem("company_context", JSON.stringify(merged));
          localStorage.setItem("company_profile_completed", "true");
          localStorage.setItem(
            "company_name",
            merged.legal_name || merged.company_name || companyName || ""
          );
        } catch (err) {
          console.error("company_context update failed", err);
        }

        localStorage.removeItem("connect_mode");
        localStorage.removeItem("return_to");

        navigate(returnTo || "/company-dashboard", { replace: true });
        return;
      }

      // Firma existiert schon -> zurück ins Dashboard, nicht ins Profil
      if (companyId) {
        try {
          const existingContext = readCompanyContext();

          const merged = {
            ...existingContext,
            company_id: companyId,
            provider_type: "cobot",
            provider_context_id: spaceId,
            legal_name:
              existingContext.legal_name ||
              existingContext.company_name ||
              companyName ||
              "",
            company_name:
              existingContext.company_name ||
              existingContext.legal_name ||
              companyName ||
              "",
            completed: true,
          };

          localStorage.setItem("company_context", JSON.stringify(merged));
          localStorage.setItem("company_profile_completed", "true");
          localStorage.setItem(
            "company_name",
            merged.legal_name || merged.company_name || companyName || ""
          );
        } catch (err) {
          console.error("company_context refresh failed", err);
        }

        localStorage.removeItem("connect_mode");
        localStorage.removeItem("return_to");
        navigate("/company-dashboard", { replace: true });
        return;
      }

      // Erstes Onboarding über Cobot
      navigate("/profile", { replace: true });
    };

    run();
  }, [location.search, location.hash, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center text-blue-700 text-lg">
      🔄 Authentifizierung wird abgeschlossen…
    </div>
  );
};

export default Callback;